<template>
  <el-drawer class="sideDrawer" destroy-on-close :size="drawerSize" :wrapperClosable="false" title="提醒设置" :visible="DialogShow" :before-close="closeRemind">
    <div slot="title" class="dialog-header-title">
      <span class="name">提醒设置</span>
    </div>
    <div class="dialogContent" v-if="DialogShow" style="padding: 20px">
      <div class="each">
        <p class="before">剩余</p>
        <el-input v-model="form.days" type="number" @blur="blurInpur" style="width: 100px" />
        <p class="after">天，快到期提醒</p>
      </div>
      <div class="each">
        <p class="before">推送时间：</p>
        <el-time-picker v-model="form.push_time" value-format="HH:mm:ss" format="HH:mm" placeholder="选择推送时间" />
      </div>
      <div class="each">
        <p class="before">推送给相关人：</p>
        <el-input style="width: 192px" v-model="form.user_account" placeholder="请选择" @focus="showUserDialog" />
      </div>
      <div class="each">
        <p class="before">推送方式：</p>
        <el-checkbox-group v-model="form.typeList" @change="checkChange">
          <el-checkbox v-for="item in ReminderList" :key="item.index" :label="item.value">{{ item.label }}</el-checkbox>
        </el-checkbox-group>
      </div>

      <!-- 用户选择器 -->
      <eip-user-dialog ref="eipUserDialog" @onConfirm="userDialogOnConfirm" :single="true" append-to-body />
    </div>
    <div class="demo-drawer__footer">
      <el-button @click="reset()" size="small">恢复默认</el-button>
      <el-button type="primary" size="small" @click="submitForm()">保存</el-button>
    </div>
  </el-drawer>
</template>

<script>
import EipUserDialog from '@/components/dialog/EipUserDialog.vue'

export default {
  props: ['show', 'data'],
  components: {
    EipUserDialog
  },
  data() {
    return {
      drawerSize: '28%',
      ReminderList: [
        {
          label: '站内信',
          value: 'inner'
        },
        {
          label: '邮箱',
          value: 'mail'
        },
        {
          label: '短信',
          value: 'sms'
        }
      ],
      DialogShow: false,
      form: {
        typeList: [],
        refId: '',
        alert_type: 1
      },
      rules: {}
    }
  },
  watch: {
    show: {
      handler(newVal) {
        this.DialogShow = newVal
        if (this.DialogShow) {
          this.form = {
            typeList: [],
            refId: '',
            alert_type: 1
          }
          this.getDetail()
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {},
  methods: {
    // 获取详情
    getDetail() {
      this.$http.get('${third}/costcenter/accounting_alert/getByAccountManagementId/' + this.data.id).then(
        (resp) => {
          if (resp.data) {
            this.form = resp.data
            let pushArr = []
            if (resp.data.push_way) {
              const arr = resp.data.push_way.split(',')
              arr.forEach((e) => {
                if (e) pushArr.push(String(e))
              })
              this.$set(this.form, 'typeList', pushArr)
            }
            if (resp.data.user_id) {
              this.$http.get('${uc}/api/user/v1/user/getUserById?userId=' + resp.data.user_id).then((re) => {
                if (re.data.value) this.$set(this.form, 'user_account', re.data.value.account)
              })
            }
          } else {
            this.reset(true)
          }
        },
        (error) => {
          reject(error)
        }
      )
    },
    checkChange(val) {
      console.log(val)
    },
    // 剩余次数整数转化
    blurInpur() {
      if (Number(this.form.days) >= 0) this.$set(this.form, 'days', parseInt(this.form.days))
      else this.form.days = 0
    },
    // 恢复默认
    reset() {
      this.$http.get('${uc}/api/user/v1/user/getDetailByAccountOrId?account=admin').then((resp) => {
        if (resp.data.user) {
          this.form = Object.assign({}, this.form, {
            days: 30,
            push_time: '09:00:00',
            typeList: ['sms'],
            alert_type: 1,
            user_name: resp.data.user.fullname,
            user_account: 'admin',
            user_id: resp.data.user.userId
          })
        }
      })
    },
    // 保存
    submitForm() {
      if (!this.form.days && this.form.days != 0) this.$message.error('请填写剩余天数')
      else if (!this.form.push_time) this.$message.error('请选择推送时间')
      else if (!this.form.user_name) this.$message.error('请选择推送相关人')
      else if (this.form.typeList.length == 0) this.$message.error('请选择推送方式')
      else {
        if (this.form.id) this.putSubmit()
        else this.postSubmit()
      }
    },
    //更新提醒
    putSubmit() {
      this.form.push_way = this.form.typeList.join(',')
      this.$http.put('${third}/costcenter/accounting_alert/', this.form).then(
        (resp) => {
          if (resp.data.state) {
            this.$message.success('操作成功')
            setTimeout(() => {
              this.closeRemind()
            }, 1000)
          }
        },
        (error) => {
          reject(error)
        }
      )
    },
    //创建提醒
    postSubmit() {
      this.form.refId = this.data.id

      this.form.push_way = this.form.typeList.join(',')
      this.$http.post('${third}/costcenter/accounting_alert/', this.form).then(
        (resp) => {
          if (resp.data.state) {
            this.$message.success('保存成功')
            setTimeout(() => {
              this.closeRemind()
            }, 1000)
          }
        },
        (error) => {
          reject(error)
        }
      )
    },
    // 打开用户选择器
    showUserDialog() {
      this.$refs.eipUserDialog.showDialog()
    },
    // 用户选择器回显
    userDialogOnConfirm(selection) {
      if (!selection || selection.length == 0) {
        if (!this.form.user_name && this.form.user_id) {
          this.form.user_name = ''
          this.form.user_account = ''
          this.form.user_id = ''
        }
      } else {
        this.$set(this.form, 'user_account', selection[0].account)
        this.$set(this.form, 'user_name', selection[0].fullname)
        this.$set(this.form, 'user_id', selection[0].id)
      }
    },
    //关闭对话框
    closeRemind() {
      this.DialogShow = false
      this.$emit('closeReminderDialog')
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  margin: 0;
  padding: 0;
}
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

/deep/ input::-webkit-outer-spin-button {
  -webkit-appearance: none !important;
}

input[type='number'] {
  -moz-appearance: textfield;
}
.each {
  display: flex;
  margin-bottom: 20px;
  align-items: center;
  .before {
    margin-right: 20px;
    flex-shrink: 0;
  }
  .after {
    margin-left: 20px;
  }
}
.name {
  font-weight: bold;
}
</style>
